<form [formGroup]="appForm" *ngIf="appForm" class="p-4 app-details">
  <!-- App Name -->
  <div class="form-group row mb-4">
    <label class="col-12 col-form-label required mb-2 fw-semibold" for="name">
      {{ 'APP_NAME' | translate }}
    </label>
    <div class="col-12">
      <input
        formControlName="name"
        id="name"
        type="text"
        class="form-control w-100 p-inputtext-lg"
        pInputText
        [ngClass]="{ 'ng-invalid ng-dirty': (submitted || appForm.get('name')?.dirty) && appForm.get('name')?.invalid }"
        placeholder="Enter App Name"
      />
      <small
        *ngIf="appForm.get('name')?.invalid && (submitted || appForm.get('name')?.dirty)"
        class="d-block mt-1 text-danger text-xs"
      >
        <span *ngIf="appForm.get('name')?.hasError('required')" class="d-block">{{
          'APP_NAME_REQUIRED' | translate
        }}</span>
        <span *ngIf="appForm.get('name')?.hasError('pattern')" class="d-block">{{
          'APP_NAME_PATTERN' | translate
        }}</span>
        <span *ngIf="appForm.get('name')?.hasError('maxlength')" class="d-block">{{
          'APP_NAME_LENGTH_VALIDATION' | translate
        }}</span>
      </small>
    </div>
  </div>

  <!-- App Short Name -->
  <div class="form-group row mb-4">
    <label class="col-12 col-form-label required mb-2 fw-semibold" for="shortName">
      {{ 'SHORT_NAME' | translate }}
    </label>
    <div class="col-12">
      <input
        formControlName="shortName"
        id="shortName"
        type="text"
        class="form-control w-100 p-inputtext-lg"
        pInputText
        [ngClass]="{
          'ng-invalid ng-dirty': (submitted || appForm.get('shortName')?.dirty) && appForm.get('shortName')?.invalid
        }"
        placeholder="Enter App Short Name"
      />
      <small
        *ngIf="appForm.get('shortName')?.invalid && (submitted || appForm.get('shortName')?.dirty)"
        class="d-block mt-1 text-danger text-xs"
      >
        <span *ngIf="appForm.get('shortName')?.hasError('required')" class="d-block">{{
          'APP_SHORTNAME_REQUIRED' | translate
        }}</span>
        <span *ngIf="appForm.get('shortName')?.hasError('pattern')" class="d-block">{{
          'APP_SHORTNAME_PATTERN' | translate
        }}</span>
        <span *ngIf="appForm.get('shortName')?.hasError('maxlength')" class="d-block">{{
          'SHORT_NAME_LENGTH_VALIDATION' | translate
        }}</span>
      </small>
    </div>
  </div>

  <!-- Footer Actions -->
  <div class="footer-actions d-flex justify-content-end gap-2 mt-4 pt-3">
    <button
      pButton
      type="button"
      label="Cancel"
      class="p-button-outlined p-button-secondary"
      (click)="onCancel.emit()"
      [disabled]="isUpdating"
    ></button>
    <button
      pButton
      type="button"
      label="Update"
      class="p-button-primary px-4"
      (click)="onApplicationUpdate()"
      [disabled]="isUpdating"
      [icon]="isUpdating ? 'pi pi-spin pi-spinner' : ''"
      iconPos="right"
    ></button>
  </div>
</form>
